import React from 'react';
import ArrowDown from 'material-ui/svg-icons/navigation/arrow-drop-down';
import IconButton from 'material-ui/IconButton';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import Theme from 'styles/theme';

class DashboardDropdown extends React.PureComponent {
  constructor(props) {
    super(props);
    this.itemTouchTapHandler = this.itemTouchTapHandler.bind(this);
    this.openMenu = this.openMenu.bind(this);
    this.closeMenu = this.closeMenu.bind(this);

    this.state = {
      menuOpen: false,
    };

    this.arrowButtonColor = Theme.palette.minorButtonGrey;
  }

  /**
   * Handle the event when a <MenuItem/> was selected / tapped
   * @param item  the selected item
   */
  itemTouchTapHandler(item) {
    const selectionChanged = this.props.selectedItem !== item;
    if (selectionChanged) {
      this.props.updateSelection(item);
    }
  }

  componentDidMount() {
    document.addEventListener('click', this.closeMenu, true);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.closeMenu, true);
  }

  openMenu() {
    this.setState({
      menuOpen: true,
    });
  }

  closeMenu() {
    this.setState({
      menuOpen: false,
    });
  }

  render() {
    // the menu items might have changes so this needs to happen in a method that gets called when props are updated
    const menuItems = this.props.selectionOptions.map(item => (
      <MenuItem
        className="dashboard-dropdown-menu-item"
        primaryText={item[this.props.textProperty]}
        key={item[this.props.keyProperty]}
        onClick={() => this.itemTouchTapHandler(item)}
      />
    ));

    const defaultText = menuItems.length > 0 ? this.props.defaultText : this.props.emptyText;
    const displayText = this.props.selectedItem
      ? this.props.selectedItem[this.props.textProperty]
      : defaultText;

    return (
      <div className="dashboard-dropdown" onClick={this.openMenu}>
        <span className="current">{displayText}</span>
        {menuItems.length > 0 && (
          <IconMenu
            iconButtonElement={
              <IconButton className="dashboard-dropdown-icon-menu" style={this.iconButtonStyle}>
                <ArrowDown color={this.arrowButtonColor} />
              </IconButton>
            }
            open={this.state.menuOpen}
            animated={true}
            anchorOrigin={{horizontal: 'left', vertical: 'bottom'}}
            targetOrigin={{horizontal: 'left', vertical: 'top'}}
            className="arrow-down"
            useLayerForClickAway={true}>
            {menuItems}
          </IconMenu>
        )}
      </div>
    );
  }
}

DashboardDropdown.displayName = 'DashboardDropdown';
export default DashboardDropdown;
